import { Grid, TextField, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../app/hooks";
import { routineItemInsUpdSlice, selectRoutineItemInsUpd } from "../../../redux/routine/routineItemInsUpdSlice";
import AvatarUploadDragAndDrop from "../../../features/base/image/AvatarUploadDragAndDrop";

export function RoutineItemInsUpdData() {
    const routineItemInsUpd = useSelector(selectRoutineItemInsUpd);
    const dispatch = useAppDispatch();

    const changedName = (event: React.ChangeEvent<HTMLInputElement>) => {
        console.debug("changed routine item name", event.target.value);
        event.preventDefault();
        const routineItem = {
            ...routineItemInsUpd.routineItem
        };
        routineItem.name = event.target.value;
        dispatch(routineItemInsUpdSlice.actions.set(routineItem));
    };

    const changedOrder = (event: React.ChangeEvent<HTMLInputElement>) => {
        console.debug("changed routine item order", event.target.value);
        event.preventDefault();
        const routineItem = {
            ...routineItemInsUpd.routineItem
        };
        routineItem.order = parseInt(event.target.value);
        if (isNaN(routineItem.order)) {
            routineItem.order = undefined;
        }
        dispatch(routineItemInsUpdSlice.actions.set(routineItem));
    };

    const handleAvatarChange = (img: string) => {
        const routineItem = {
            ...routineItemInsUpd.routineItem,
            url: img
        };
        dispatch(routineItemInsUpdSlice.actions.set(routineItem));
    };

    return <>
        <Typography variant="h6" gutterBottom>
            Dados do item da rotina
        </Typography>
        <Grid container spacing={3}>
            <Grid size={12}>
                <TextField required id="name" name="name" label="Nome"
                    fullWidth autoComplete="nome" variant="standard"
                    value={routineItemInsUpd.routineItem.name}
                    onChange={changedName} />
            </Grid>
            <Grid size={6}>
                <TextField required id="order" name="ordem" label="Ordem"
                    type="number"
                    fullWidth autoComplete="nome" variant="standard"
                    value={routineItemInsUpd.routineItem.order}
                    onChange={changedOrder} />
            </Grid>
            <Grid size={12}>
                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                    Avatar
                </Typography>
                <AvatarUploadDragAndDrop
                    value={routineItemInsUpd.routineItem.url || ""}
                    onChange={handleAvatarChange}
                    alt={routineItemInsUpd.routineItem.name}
                />
            </Grid>
        </Grid>
    </>;
}